const firebaseConfig = {
  apiKey: "AIzaSyCVnXL3pwzDmuJRJQlmQ2K-gpsh0LrHlos",
  authDomain: "skillshikhun.firebaseapp.com",
  projectId: "skillshikhun",
  storageBucket: "skillshikhun.appspot.com",
  messagingSenderId: "90542271897",
  appId: "1:90542271897:web:3b3848ebeaec042098b708",
  measurementId: "G-ZK1Q7N6W7W"
};

export default firebaseConfig;